import * as actionTypes from "Application/Store/Actions/HistoryTypes"

/*****************************************************************
 *  History Reducer
 * ***************************************************************/

const initialState = {
  loading: 'Starting project',
  popup: null,
  popupType: null
}

/**
 * Update State
 * @param {object} state 
 * @param {*} action 
 * @returns 
 */
export const HistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOADING_ACTION:
      return {
        ...state,
        loading: action.payload
      }
    case actionTypes.SET_POPUP:
      return {
        ...state,
        popup: action.payload?.content || action.payload,
        popupType: action.payload?.type || null
      }
    case actionTypes.CLEAR_POPUP:
      return {
        ...state,
        popup: null,
        popupType: null
      }
    default:
      return state
  }
}